import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

const FollowMouse = () => {
  const { followMouse } = useSelector((state) => state.followMouse);

  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener("mousemove", handleMouseMove);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  if (!followMouse) return null;

  return (
    <div
      style={{
        position: "fixed",
        width: "14px",
        height: "14px",
        borderRadius: "50%",
        backgroundColor: "#fe8900",
        left: `${mousePosition.x - 7}px`,
        top: `${mousePosition.y - 7}px`,
        pointerEvents: "none",
        transition: "transform 0.1s ease-out",
        zIndex: 3000,
      }}
    ></div>
  );
};

export default FollowMouse;
